<template>
  <ModalTerms
    ref="modal"
    :gtc="gtc"
    :checkbox-text="checkboxText"
    :is-creating="isCreating"
    @accept="accept"
    :title="title"
    @downloadExcel="downloadExcel"
    :showDownloadLink="showDownloadLink"
  />
</template>

<script>
import axios from 'axios';
import qs from 'qs';

import ModalTerms from '../components/ModalTerms.vue';

export default {
  name: 'ModalTermsContainer',
  components: { ModalTerms },
  props: {
    gtc: {
      type: String,
      default: null,
    },
    checkboxText: {
      type: String,
      default: null,
    },
    fieldIds: {
      type: Array,
      required: true,
    },
    companyData: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default() {
        return this.$t('Vereinbarungen zur Flächenmeldung');
      },
    },
    contractAdditionalData: {
      type: Object,
      default: () => ({}),
    },
    showDownloadLink: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isCreating() {
      return this.$store.state.digitalContracting.creating != null;
    },
  },
  methods: {
    downloadExcel() {
      const companyId = this.$store.state.auth.currentCompanies?.[0]?.id;
      const contract = this.$store.state.digitalContracting.contracting;

      const noHerbicideWineFruitHops = {
        2023: this.contractAdditionalData.processOrderData['2023'].noHerbicideWineFruitHops,
        2024: this.contractAdditionalData.processOrderData['2024'].noHerbicideWineFruitHops,
      };

      const noInsecticideWineFruitHops = {
        2023: this.contractAdditionalData.processOrderData['2023'].noInsecticideWineFruitHops,
        2024: this.contractAdditionalData.processOrderData['2024'].noInsecticideWineFruitHops,
      };

      const organicFarming = {
        2023: this.contractAdditionalData.processOrderData['2023'].organicFarming,
        2024: this.contractAdditionalData.processOrderData['2024'].organicFarming,
      };

      const params = {
        companyId,
        contractId: contract.guid,
        organicFarming,
        noHerbicideWineFruitHops,
        noInsecticideWineFruitHops,
      };

      const queryString = qs.stringify(params, {
        encode: false,
        arrayFormat: 'brackets',
      });

      const url = `${origin}/rest/reports/psm-stats/xlsx?${queryString}`;

      axios.get(url, { responseType: 'blob' }).then((response) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', 'Verwendung_von_Pflanzenschutzmittel_2023-2024_fd.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      });
    },
    show() {
      if (this.$refs.modal == null) {
        return;
      }
      this.$refs.modal.show();
    },
    hide() {
      if (this.$refs.modal == null) {
        return;
      }
      this.$refs.modal.hide();
    },
    async accept() {
      try {
        await this.$store.dispatch('digitalContracting/accept', {
          fieldIds: this.fieldIds,
          companyData: this.companyData,
          newsletter: 0,
          contractAdditionalData: this.contractAdditionalData,
        });
      } catch (e) {
        console.error('Unable to accept contract.', e);
      } finally {
        this.$refs.modal.hide();
      }
    },
  },
};
</script>

<style scoped></style>
